// Core components
import { Component, OnDestroy, OnInit } from "@angular/core";

// Third party components
import { FieldType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";

// Custom components
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";

/**
 * Script start
 */
@Component({
  selector: "formly-select-structure-section",
  template: `
    <app-card-spinner [visible]="dataIsLoading" type="zero"></app-card-spinner>
    <div *ngFor="let item of items">
      <div class="connection-label">
        <strong>{{ item.name | translate }}</strong>
      </div>
      <div *ngFor="let subItem of item.values">
        <mat-checkbox
          [value]="subItem.value"
          [checked]="model.connessioni && model.connessioni.includes(subItem.value)"
          (change)="onChange(subItem.value)"
          [disabled]="to.disabled"
        >
          {{ subItem.viewValue }}
        </mat-checkbox>
      </div>
    </div>
  `
})
export class SelectStructureTypeComponent extends FieldType implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  items: any[] = [];
  dataIsLoading = true;

  constructor(
    private condoStructuresService: CondoStructuresService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    const condoStructureId = this.activatedRoute.snapshot.params.mappingFormActiveSection
      .split("/")[1];

    this.subscriptions.push(
      this.condoStructuresService
        .getCondoStructuresListForSelect(condoStructureId)
        .subscribe(res => {
          if (res.status) {
            this.items = (res.data && res.data.items) || res.items || [];
            this.dataIsLoading = false;
          }
        })
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  /**
   * Handle onChange event
   *
   * @since 1.0.0
   */
  onChange(value: any): void {
    if (!value) {
      return;
    }

    if (!this.model.connessioni) {
      this.model.connessioni = [];
    }

    if (!this.model.connessioni.includes(value)) {
      // Add connection
      this.model.connessioni.push(value);
    } else if (this.model.connessioni.includes(value)) {
      // Remove connection
      this.model.connessioni.splice(this.model.connessioni.indexOf(value), 1);
    }

    // Set form value
    if (this.form.controls.connessioni) {
      this.form.controls.connessioni.setValue(this.model.connessioni);
    }
  }
}
